(function () {
  'use strict';

  angular
      .module('tf.retailer.Api', [])
      .factory('Api', Api)
      .constant('ApiStatusCodes', {
          "NotFound": 404,
          "InternalError": 500
       }
      )
      .factory('ApiFallback', ApiFallback)
      .factory('ApiErrorHandler', ApiErrorHandler);

  // @ngInject
  function Api($http, $q) {
    var BASE = '/retailer/ui';
    var api = createApi(BASE);
    api.withBasePath = withBasePath;
    api.getBasePath = getBasePath;
    api.withEncodedPath = getEncodedPath;
    return api;

    function withBasePath(path) {
      return createApi(BASE + path);
    }

    // Method to get base path of url
    function getBasePath(){
      return BASE;
    }

    // Method to get url with encoded value
    function getEncodedPath(path, pathParam) {
      return path + encodeURIComponent(pathParam)
    }

    function createApi(basePath) {

      // add shortcut methods
      ['get', 'delete', 'head', 'jsonp'].map(createShortMethod);
      ['post', 'put', 'patch'].map(createShortMethodWithData);

      // readonly property
      apiRequest.basePath = basePath;

      return apiRequest;

      function apiRequest(config) {
        config.url = apiUrl(config.url);
        return handleRequest($http(config));
      }

      function apiUrl(url) {
        return basePath + url;
      }

      function createShortMethod(method) {
        apiRequest[method] = function (url, config, fallBack) {
          return handleRequest($http[method](apiUrl(url), config), fallBack);
        };
      }

      function createShortMethodWithData(method) {
        apiRequest[method] = function (url, data, config, fallBack) {
          return handleRequest($http[method](apiUrl(url), data, config), fallBack);
        };
      }

      function handleRequest(promise, fallBack) {
        return promise
            .catch(function (reason) { return apiFailure(reason, fallBack) });
      }

      //fallBack to be passed as array of objects specifying error codes and their handler functions
      function apiFailure(response, fallBacks) {
        var handler = _.isArray(fallBacks) && _.find(fallBacks, function (fallback) {
          return fallback.isStatusCodeHandled(response.status);
        });
        if (handler) {
          return handler.handle(response);
        } else {
          return $q.reject(response);
        }

      }

    }
  }

  function ApiFallback() {

    return {
      createFallback : function (isStatusCodeHandled, handle) {
        return [{
          "isStatusCodeHandled": isStatusCodeHandled,
          "handle": handle
        }];
      }
    };
  }

  function ApiErrorHandler($q, $injector) {

    return {
      responseError: function(err) {
        if(!err.config["specificallyHandled"]) {
          toastError(err);
        }
        return $q.reject(err);
      },
      toastError: toastError
    };

    function toastError(error) {
      var Toast = $injector.get('Toast');
      var status = error && error.status;
      switch(status) {
        case 403: // Forbidden
          Toast.error("Site.Error.LackPrivilege");
          break;
        case 404: // Page not found
          Toast.error("Site.Error.ServiceUnavailable");
          break;
        default:
          if (status >= 500) {
            Toast.error("Site.Error.ServiceUnavailable");
          }
      }
      return status;
    }

  }


})();
